const e = "style-module__fileTextContainer___t7MS2", t = "style-module__fileName___EFcui", n = "style-module__full___8CuHg", _ = "style-module__icon___-ee-4", o = "style-module__receiver___EuJeI", l = "style-module__filePreviewContainer___jCqRg", i = "style-module__contextMenuContainer___xgHLv", s = "style-module__contextMenu___6qG7n", r = "style-module__fileImageContainer___b8ANp", a = "style-module__fileImage___ES8CE", c = "style-module__textContent___HsktQ", u = "style-module__sender___XwbQ8", m = "style-module__noPreviewContainer___PGDRv", C = "style-module__bgOverlay___P-Ojf", f = {
  fileTextContainer: e,
  fileName: t,
  full: n,
  icon: _,
  receiver: o,
  filePreviewContainer: l,
  contextMenuContainer: i,
  contextMenu: s,
  fileImageContainer: r,
  fileImage: a,
  textContent: c,
  sender: u,
  noPreviewContainer: m,
  bgOverlay: C
};
export {
  C as bgOverlay,
  s as contextMenu,
  i as contextMenuContainer,
  f as default,
  a as fileImage,
  r as fileImageContainer,
  t as fileName,
  l as filePreviewContainer,
  e as fileTextContainer,
  n as full,
  _ as icon,
  m as noPreviewContainer,
  o as receiver,
  u as sender,
  c as textContent
};
